/**
 * 语言
 */
export enum enum_base_language {
	"en-US" = "en-US",
	"ja-JP" = "ja-JP",
	"es-ES" = "es-ES",
	"sv-SE" = "sv-SE",
	"it-IT" = "it-IT",
	"de-DE" = "de-DE",
	"nb-NO" = "nb-NO",
	"ru-RU" = "ru-RU",
	"hu-HU" = "hu-HU",
	"pl-PL" = "pl-PL",
	"sk-SK" = "sk-SK",
	"fr-FR" = "fr-FR"
}

/**
 * 性别
 */
export enum enum_base_gender {
	"Unknown" = 0,
	"Male" = 1,
	"Female" = 2
}

/**
 * 审核状态
 */
export enum enum_audit_status {
	"Reviewing" = 1,
	"Success" = 2,
	"Reject" = 3
}

/**
 * 交易流水 类型
 * @description 1-上分 2-下分 3-充值 4-提现冻结 5-提现解冻 6-提现 7-任务 8-本金返回 9-返佣 10-下级返佣 11-签到 12-手续费 100-其他
 */
export enum enum_trading_kind {
	UpSplit = 1,
	DownSplit = 2,
	Recharge = 3,
	Freeze = 4,
	Unfreeze = 5,
	Withdrawal = 6,
	Tasks = 7,
	PrincipalReturn = 8,
	Rebate = 9,
	SubordinateRebates = 10,
	CheckIn = 11,
	HandlingFee = 12,
	Other = 13
}
